export const VIDEO_MAX_SECONDS = 120;
export const VIDEO_MAX_BYTES = 80 * 1024 * 1024;

export const VIDEO_MIME_TYPES = ["video/mp4", "video/quicktime", "video/webm"] as const;
export const MEDIA_ACCEPT_ATTR = `image/*,${VIDEO_MIME_TYPES.join(",")}`;

const VIDEO_EXT_BY_MIME: Record<string, string> = {
	"video/mp4": "mp4",
	"video/quicktime": "mov",
	"video/webm": "webm",
};

export function videoExtFromMime(mime: string): string {
	return VIDEO_EXT_BY_MIME[mime] ?? "mp4";
}

export function isVideoUrl(url: string): boolean {
	const lower = url.toLowerCase();
	return lower.endsWith(".mp4") || lower.endsWith(".webm") || lower.endsWith(".mov");
}

export const THUMB_SUFFIX = ".thumb";
export const POSTER_SUFFIX = ".poster.webp";

export function encodeImageFilename(uuid: string, width: number, height: number, ext: string, thumbnail = false): string {
	const w = Math.max(0, Math.round(width));
	const h = Math.max(0, Math.round(height));
	const dims = w && h ? `.${w}x${h}` : "";
	const thumb = thumbnail ? THUMB_SUFFIX : "";
	return `${uuid}${dims}${thumb}.${ext}`;
}

export function parseImageDimensions(url: string): { width: number; height: number } | null {
	const match = url.match(/\.(\d+)x(\d+)(?:\.thumb)?\.[^./]+(?:[?#]|$)/);
	if (!match) return null;
	return { width: Number(match[1]), height: Number(match[2]) };
}

export function toThumbUrl(mainUrl: string): string {
	const match = mainUrl.match(/^(.*?)(\.\d+x\d+)?(\.[^./?#]+)([?#].*)?$/);
	if (!match) return mainUrl;
	const [, stem, , ext, suffix = ""] = match;
	if (stem.endsWith(THUMB_SUFFIX)) return mainUrl;
	return `${stem}${THUMB_SUFFIX}${ext}${suffix}`;
}

export function toPosterUrl(videoUrl: string): string {
	const match = videoUrl.match(/^([^?#]*)([?#].*)?$/);
	if (!match) return `${videoUrl}${POSTER_SUFFIX}`;
	const [, path, suffix = ""] = match;
	return `${path}${POSTER_SUFFIX}${suffix}`;
}
